import { useEffect, useRef } from 'react'
import QRCode from 'qrcode'
import type { QRCodeType } from 'utils/constants'

interface BaseQRCodeContent {
	type: QRCodeType
	data?: Record<string, unknown>
}

interface AuthenticatorQRCodeContent extends BaseQRCodeContent {
	type: QRCodeType.Authenticator
	data: {
		code: string
	}
}

interface CouponQRCodeContent extends BaseQRCodeContent {
	type: QRCodeType.Coupon
	data: {
        // TODO: to adapt once we support encoding coupon data
        couponCode: string
    }
}

interface RequireLoginCouponQRCodeContent extends BaseQRCodeContent {
	type: QRCodeType.RequireLoginCoupon
	data: {
        couponCode: string
        authCode: string
    }
}

interface RequireLoginExternalCouponQRCodeContent extends BaseQRCodeContent {
	type: QRCodeType.RequireLoginExternalCoupon
	data: {
        rawCode: string
        authCode: string
    }
}

interface QRCodeProps {
    content?: AuthenticatorQRCodeContent | CouponQRCodeContent | RequireLoginCouponQRCodeContent | RequireLoginExternalCouponQRCodeContent
}

const QRCodeCanvas = ({content}: QRCodeProps) => {
    const qrCodeContainerRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if(content) {
            QRCode.toCanvas(JSON.stringify(content), { errorCorrectionLevel: 'H', margin: 0 }, (err, canvas) => {
                if (err) { throw err }
                qrCodeContainerReset(canvas)
            })
        }
        else {
            qrCodeContainerReset()
        }
    }, [content])

    const qrCodeContainerReset = (canvas?: HTMLCanvasElement) => {
        const container = qrCodeContainerRef.current
        while (container?.firstChild) {
            container.removeChild(container.firstChild);
        }

        if(canvas) {
            container?.appendChild(canvas)
        }
    }

    return (
        <div ref={qrCodeContainerRef} />	
    )
}

export default QRCodeCanvas

